import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccessControlService } from '../services/accessControl.service';

@Injectable({
  providedIn: 'root'
})
export class AccessControlEditGuard implements CanActivate {
  constructor(
    private accessControlService: AccessControlService,
    private router: Router
    ){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.accessControlService.STB){
        //return this.router.navigate(["/app/access"]).then(() => false);
      }
      return true;
  }
  
}
